  <template>
  <div class="users-style">
    <h4 class="atlhr-dashboard-title mt-10">Provident and Gratuity Fund Management<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Provident and Gratuity Fund Management</span></h4>
  	<div v-if="success != ''" class="alert alert-success" role="alert"> {{success}} </div>
    <div v-if="error_msg != ''" class="alert alert-danger" role="alert"> {{error_msg}} </div>
    <div class="row">
        <div class="col-md-6">
            <table class="table">
                <tr>
                    <td class="custom-taxcard-select custom-payrun-select p-0">                     
                       <div class="d-inline-block max-200 mr-2">
                        <span class="custom-select-label mr-3">Fiscal Year:</span>
                        <select v-model="search.fiscal_year"  class="form-control custom-select" @change="setSearch()">                       
                           <option v-for='fyear in payrunsfiscalyear'  :value='fyear.fiscal_year'>{{fyear.fiscal_year }}</option>
                      </select>
                        </div>
                        <div class="d-inline-block max-200"> 
                        <span class="custom-select-label mr-3">Month:</span>
                        <select v-model="search.month" class="form-control custom-select" @change="setSearch()" >
                        <option value="June">June {{year_segment4}}</option>
                        <option value="May">May {{year_segment4}}</option>
                        <option value="April">April {{year_segment4}}</option>
                        <option value="March">March {{year_segment4}}</option>
                        <option value="February">February {{year_segment4}}</option>
                        <option value="January">January {{year_segment4}}</option>
                        <option value="December">December {{year_segment3}}</option>
                        <option value="November">November {{year_segment3}}</option>
                        <option value="October">October {{year_segment3}}</option>
                        <option value="September">September {{year_segment3}}</option>
                        <option value="August">August {{year_segment3}}</option>
                        <option value="July">July {{year_segment3}}</option>
                        </select>
                        </div>
                    </td> 
                </tr>
            </table> 

            
        </div>
         <div class="col-md-6 mt-4 text-right">
            <div class="rounded h-100"> 
             
              <a class="btn btn-primary" style="color: #FFFFFF; " :href="pgurl+'/pfandgfrun/wizard'" v-if="!payslip_process"><i class="fa fa-bullseye" aria-hidden="true"></i>
 Run PF and GF Now</a>
              <!-- <a class="btn btn-primary" style="color: #FFFFFF; " href="javascript: void(0)" @click="runOffcycle()" v-if="!payslip_process"><i class="fa fa-certificate" aria-hidden="true"></i>
 Run Off-Cycle Payroll</a>
              <a class="btn btn-primary" style="color: #FFFFFF; display: none;" href="javascript: void(0)" @click="runFinalsettltment()" v-if="!payslip_process">Run Final Settlement</a> -->
		
        	</div>
        </div>
       
    </div>
    
  
    
    
<div><b-modal id="pass-modal" title="Are you sure to unapprove this Gratuity Fund Run?" hide-footer> Please enter your password to continue:
 <br />
 <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 

 <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
 <div style="height: 10px;clear:both;"> &nbsp;</div>
  <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="unapprovePayrun(unapproval_payrun_id)">Unapprove <span v-if="loading != ''"><img :src="pgurl+'/images/loading.gif'" width="20"></span></a>
  &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('pass-modal')">Cancel</a>
  <div style="height: 5px;clear:both;"> &nbsp;</div>
 </b-modal></div>
 
 
 <div><b-modal id="approve-modal" title="Are you sure you want to approve this Gratuity Fund Run?" hide-footer> Please enter your password to continue:
 <br />
 <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 

 <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
 <div style="height: 10px;clear:both;"> &nbsp;</div>
  <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="approvePayrun(approval_payrun_id)">Approve <span v-if="loading != ''"><img :src="pgurl+'/images/loading.gif'" width="20"></span></a>
  &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('approve-modal')">Cancel</a>
  <div style="height: 5px;clear:both;"> &nbsp;</div>
 </b-modal></div>
 
    
   	<h5 class="mt-2 mb-3 border-bottom pb-3">Draft Provident and Gratuity Fund Runs</h5>
    <table class="table dataTable custom-payrun-table" v-if="pending_payruncount!=0">
	  <thead>
        <tr class="table-head table-head-center">
		  
          <th class="text-left">Month</th>
          <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
		  <th>Log</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row hover-bg" v-for="prun in paginatedData" :key="prun.id">
		  <template v-if="prun.status == 2">
          <template v-if="!payslip_process_two">
          <td class="text-left"><span v-if="prun.locked!=1"><a style="cursor:pointer;" :href="pgurl+'/provident-gratuity-fund-runs-payslips/'+prun.id+''">{{prun.month}} {{prun.year}}</a></span><span v-else>{{prun.month}} {{prun.year}}</span></td>
		  <td class="text-center"><span v-if="prun.run_type == 0">Main</span><span v-if="prun.run_type == 9">Manual</span><span v-if="prun.run_type == 8">Manual</span><span v-if="prun.run_type == 11">Off-Cycle</span><span v-if="prun.run_type == 12">Final Settlement</span></td>
          <td class="text-center">{{prun.fiscal_year}}</td>
		 <td class="text-right">{{prun.pf_employer_contribution}}</td>
          <td class="text-right">{{prun.pf_employee_contribution}}</td>
          <td class="text-right">{{prun.total_pf_contribution}}</td>
		  <td class="text-right">{{prun.created_user_name}}</td>
		  <td class="position-relative text-right">
            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                <span v-if="prun.locked!=1"><a class="btn btn-primary" :href="pgurl+'/provident-gratuity-fund-runs-payslips/'+prun.id+''"><b-icon icon="pencil-square"></b-icon>Review</a></span> <span v-else v-b-tooltip.hover title="This payrun is locked since you already have a payrun created after this was generated."><a class="btn btn-primary" @click="showApproveModal(prun.id)"><b-icon icon="check2-circle"></b-icon>Approve</a></span>
            </div>
          </td>
          </template>
          </template>
          <template v-else>
          <td class="text-left"><span v-if="prun.locked!=1"><a style="cursor:pointer;" :href="pgurl+'/provident-gratuity-fund-runs-payslips/'+prun.id+''">{{prun.month}} {{prun.year}}</a></span><span v-else>{{prun.month}} {{prun.year}}</span></td>
		  <td class="text-center"><span v-if="prun.run_type == 0">Main</span><span v-if="prun.run_type == 9">Manual</span><span v-if="prun.run_type == 8">Manual</span><span v-if="prun.run_type == 11">Off-Cycle</span><span v-if="prun.run_type == 12">Final Settlement</span></td>
          <td class="text-center">{{prun.fiscal_year}}</td>
		  <td class="text-right">{{prun.pf_employer_contribution}}</td>
          <td class="text-right">{{prun.pf_employee_contribution}}</td>
          <td class="text-right">{{prun.total_pf_contribution}}</td>
          <td class="text-center">
            <div :id="'payrun-log-info-draft-'+prun.id"><b-icon icon="chat-right-dots-fill"></b-icon></div>
            <b-tooltip :target="'payrun-log-info-draft-'+prun.id" placement="top" custom-class="custom-tooltip">
                <div class="row no-margin">
                    <div class="col-md-12 p-0">
                        <span class="p-2 d-inline-block mt-2">Created By</span> - <span class="p-2 d-inline-block mt-2">{{prun.created_user_name}}</span> - <span class="p-2 d-inline-block mt-2">{{formatMe(prun.created_at)}}</span><span class="p-2 d-inline-block mt-2">{{formatTime(prun.created_at)}}</span>
                    </div>
                </div>
            </b-tooltip>
          </td>
		  <td class="position-relative text-right">
            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                <span v-if="prun.locked!=1"><a class="btn btn-primary" :href="pgurl+'/provident-gratuity-fund-runs-payslips/'+prun.id+''"><b-icon icon="pencil-square"></b-icon>Review</a></span> <span v-else v-b-tooltip.hover title="This payrun is locked since you already have a payrun created after this was generated."><a class="btn btn-primary" @click="showApproveModal(prun.id)"><b-icon icon="check2-circle"></b-icon>Approve</a></span>
            </div>
          </td>
          </template>
		</tr>
        <tr v-if="paginatedData.length > 0">
            <td :colspan=10>
              <div class="row p-2 float-right" >
                  
                  <b-pagination-nav v-model="this_pagination.currentPage" :number-of-pages="this_pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
              </div>
            </td>
        </tr>
        <tr v-if="paginatedData.length == 0"><td :colspan=10>{{blankmsg}}</td></tr>
	  </tbody>
	</table>
    
    
    
    <div v-if="pending_payruncount==0">No pending run found<hr /></div>


	<h5 class="mt-2 mb-3 border-bottom pb-3">Approved Provident and Gratuity Fund Runs</h5>

   <div class="text-center" v-if="approved_loader">
        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
    </div> 
    <div v-else>
	<table class="table dataTable" v-if="approved_payruncount!=0">
	  <thead>
        <tr class="table-head table-head-center">
          <th class="text-left">Month</th>
          <th v-for="column in columns_two" :key="column.name" @click="sortBy_two(column.name)":class="sortKey_two === column.name ? (sortOrders_two[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
		  <th>Log</th>
          <th class="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
		<tr class="table-row hover-bg" v-for="prun in paginatedData_two" :key="prun.id">
          <td class="text-left"><a style="cursor:pointer;" :href="pgurl+'/provident-gratuity-fund-runs-payslips/'+prun.id+''">{{prun.month}} {{prun.year}}</a></td>
          <td class="text-center"><span v-if="prun.run_type == 0">Main</span><span v-if="prun.run_type == 9">Manual</span><span v-if="prun.run_type == 8">Manual</span><span v-if="prun.run_type == 11">Off-Cycle</span><span v-if="prun.run_type == 12">Final Settlement</span></td>
		  <td class="text-center">{{prun.fiscal_year}}</td>		  
		  <td class="text-right">{{prun.pf_employer_contribution}}</td>
          <td class="text-right">{{prun.pf_employee_contribution}}</td>
          <td class="text-right">{{prun.total_pf_contribution}}</td>
		  <td class="text-center">
            <div :id="'payrun-log-info-draft-'+prun.id"><b-icon icon="chat-right-dots-fill"></b-icon></div>
            <b-tooltip :target="'payrun-log-info-draft-'+prun.id" placement="top" custom-class="custom-tooltip">
                <div class="row no-margin">
                    <div class="col-md-12 p-0">
                        <span class="p-2 d-inline-block mt-2">Created By</span> - <span class="p-2 d-inline-block mt-2">{{prun.created_user_name}}</span> - <span class="p-2 d-inline-block mt-2">{{formatMe(prun.created_at)}}</span><span class="p-2 d-inline-block mt-2">{{formatTime(prun.created_at)}}</span>
                    </div>
                    
                    <div class="col-md-12 p-0">
                        <span class="p-2 d-inline-block">Approved By</span> - <span class="p-2 d-inline-block">{{prun.approved_user_name}}</span> - <span class="p-2 d-inline-block">{{formatMe(prun.updated_at)}}</span><span class="p-2 d-inline-block">{{formatTime(prun.updated_at)}}</span>
                    </div>
                </div>
            </b-tooltip>
          </td>
		  <td class="position-relative text-right">
              <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
              <div class="dropdown-menu action-dropdown-menu w-200" aria-labelledby="actionDropdown">
                <a class="btn btn-primary" :href="pgurl+'/provident-gratuity-fund-runs-payslips/'+prun.id+''"><b-icon icon="eye"></b-icon>Detail</a> 
                <a v-if="prun.editable=='Yes'" class="btn btn-primary"  @click="checkChallanCreated(prun.id)"><b-icon icon="arrow-counterclockwise"></b-icon>Unapprove</a>
              </div>
          </td>
		</tr>
        <tr v-if="paginatedData_two.length > 0">
            <td :colspan=10>
              <div class="row p-2 float-right" >
                  
                  <b-pagination-nav v-model="this_pagination.currentPage" :number-of-pages="this_pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
              </div>
            </td>
        </tr>
        <tr v-if="paginatedData_two.length == 0"><td :colspan=10>{{blankmsg_two}}</td></tr>
	  </tbody>
	</table>
  </div>
    
    <div v-if="approved_payruncount==0">No approved run found<hr /></div>
    
 <div>
  <b-modal id="payrun_modal" :title="payrunmodaltitle"  size="lg" hide-footer @hidden="onHidden">  
  <!-- Modal Content Starts -->
  <b-card style="">
	<form @submit="formSubmit" enctype="multipart/form-data">
	  <input class="input" type="hidden" v-model="id" >
      
      <!-- Final Settlement Employee Selection-->
      <div v-if="payrun_type==2">
      <div class="form-group row">
      <div class="col-md-12">
          <label>Add Employee for the Settlement</label> <br />
            <input type="hidden" v-model="current_employee_id" >

            <input class="form-control" type="text" v-model="employeesearch.name" placeholder="Search Employee.."@input="finalSettlementsetSearch()">
           
        <table class="list1 border bg-white" id="employee_dropdown" style="width: calc(100% - 30px); border-collapse:separate; border-radius:0.25rem; -moz-border-radius:0.25rem; position: absolute; z-index: 9999999; display: none;">
		<tr v-for="user in users" :key="user.employee_id" style="border-bottom: 1px solid #CCC;">
        <td style="min-width:200px; padding: 5px 10px;"> <a style="cursor:pointer;"  @click="chooseemployee(user.name, user.employee_id)">{{user.name}}</a></td>
		
		</tr>
	   </table>
      </div>
      </div>
      
      <div v-if="employeenames.length>0">
      <span>Selected Employee(s) for Final Settlement</span>
      <table class="table">
	  <thead>
		<tr class="table-head">
		  <td>Name</td>
          <td class="text-right">Action</td>          
		</tr>
        
	  </thead>
	  <tbody>
        <tr class="hover-bg table-row"></tr>
        <tr class="hover-bg table-row" v-for="(value, index) in employeenames" :key="index">
		  <td style="min-width:200px">{{value}} </td>
		  <td class="position-relative text-right">
            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
              <div class="dropdown-menu action-dropdown-menu w-200" aria-labelledby="actionDropdown">
                <a class="btn btn-primary" style="cursor:pointer;"  @click="removeemployee(index)">Remove</a>
              </div>
          </td>
		</tr>


        </tbody>
        </table>
        </div>
      </div>
      <!-- End Final Settlement Employee Selection-->
      
      
      
      
      

	  <div class="form-group row">
		<label for="name" class="col-md-4 col-form-label">Select Fiscal Year</label>
		<div class="col-md-6">
		  <select id="year" v-model="year" name="year" required class="form-control custom-select" v-on:change="setfiscalyear()"  style="-webkit-appearance: none;">
          <option v-for='pyr in payrunyears'  :value='pyr'>{{ pyr }}</option>
		  </select>
		</div>
	  </div>      
      
	  <div class="form-group row" v-if="year">
		<label for="status"  class="col-md-4 col-form-label">Select Month</label>
		<div class="col-md-6">
		  <select id="month" v-model="month" name="Month" required class="form-control custom-select"  style="-webkit-appearance: none;">
           <!--  <option value="">Select a Month </option>
			<option value="1">January {{year_segment2}}</option>
			<option value="2">February {{year_segment2}}</option>
			<option value="3">March {{year_segment2}}</option>
			<option value="4">April {{year_segment2}}</option>
			<option value="5">May {{year_segment2}}</option>
			<option value="6">June {{year_segment2}}</option>
			<option value="7">July {{year_segment1}}</option>
			<option value="8">August {{year_segment1}}</option>
			<option value="9">September {{year_segment1}}</option>
			<option value="10">October {{year_segment1}}</option>
			<option value="11">November {{year_segment1}}</option>
			<option value="12">December {{year_segment1}}</option>-->
      <option value="7">July {{year_segment1}}</option>
      <option value="8">August {{year_segment1}}</option>
      <option value="9">September {{year_segment1}}</option>
      <option value="10">October {{year_segment1}}</option>
      <option value="11">November {{year_segment1}}</option>
      <option value="12">December {{year_segment1}}</option>
      <option value="1">January {{year_segment2}}</option>
      <option value="2">February {{year_segment2}}</option>
      <option value="3">March {{year_segment2}}</option>
      <option value="4">April {{year_segment2}}</option>
      <option value="5">May {{year_segment2}}</option>
      <option value="7">June {{year_segment2}}</option>

		  </select>
		</div>
	  </div>      
      
   	  <div class="form-group row d-none">
		<label for="status"  class="col-md-4 col-form-label">Payroll run Type</label>
		<div class="col-md-6">
		  <select id="payrun_type" v-model="payrun_type" name="payrun_type" required class="form-control " disabled style="-webkit-appearance: none;">
            <option value="0">Main Payroll Run</option>
			<option value="1">Off-Cycle Payroll Run</option>
            <option value="2">Final Settltment Payroll Run</option>
		  </select>
		</div>
	  </div>
      


	  <div class="form-group row">
		<div class="col-md-3">
		  <button class="btn btn-success btn-full-width">Submit</button>
		</div>
        
        <div class="col-md-2" v-if="loading != ''">
          <img :src="pgurl+'/images/loading.gif'" width="30">
        </div>
        
	  </div>
	</form>
    <div class="col-md-12 pay-run-loader overflow-hidden text-center" v-if="loading != ''">
        <template v-if="off_cycle_error_msg">
            <p class="text-white d-block text-center">{{off_cycle_error_msg}}</p>
            <button class="btn btn-primary" @click="hidePayrunModal()">Close</button>
        </template>
        <template v-else>
            <h3 style="color: #fff;">{{month_name}} - {{year_segment}}</h3>
            <h4 style="color: #fff;" v-if="payrun_type == 1 || payrun_type ==2"><template v-if="payrun_type == 1">Off-Cycle Payroll Run</template><template v-else>Final Settltment Payroll Run</template></h4>
            <p style="color: #fff;">Alright world, time to take you on!<br/>Payrun calculations in progress ...</p>
            <img :src="pgurl+'/images/loading.gif'" width="40">
            <div class="loading-stroke"></div>
            <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                <b-progress-bar :value="progress_value" :label="(progress_value)+' / '+(number_of_employees)"></b-progress-bar>
            </b-progress>
        </template>
    </div>
  
  
  
</b-card>
    
  <!-- Modal Content Ends -->
  </b-modal>
</div>

<div>
  <b-modal id="manual_payrun_modal" :title="'Manual Payroll Run'"  size="lg" hide-footer @hidden="onHidden">  
  <!-- Modal Content Starts -->
  <b-card style="margin: 0 30px 30px 30px; position: unset;">

     <form @submit="formSubmit_manual" enctype="multipart/form-data">
	  <div class="form-group row">
		<label for="name" class="col-md-2 col-form-label">Fiscal Year</label>
		<div class="col-md-4">
		  <select id="year" v-model="year" name="year" v-on:change="setfiscalyear()" required class="form-control">
          <!--<option value="">Select Fiscal Year</option>-->
          <option v-for='pyr in payrunyears' :value='pyr'>{{ pyr }}</option>
		  </select>
		</div>
	  </div>      
      
	  <div class="form-group row">
		<label for="status"  class="col-md-2 col-form-label">Month</label>
		<div class="col-md-4">
		  <select id="month" v-model="month" name="Month" v-on:change="setYear()"  required class="form-control ">
        <!--    <option value="">Select a Month </option>
 			<option value="7">July {{year_segment1}}</option>
			<option value="8">August {{year_segment1}}</option>
			<option value="9">September {{year_segment1}}</option>
			<option value="10">October {{year_segment1}}</option>
			<option value="11">November {{year_segment1}}</option>
			<option value="12">December {{year_segment1}}</option>
            
			<option value="1">January {{year_segment2}}</option>
			<option value="2">February {{year_segment2}}</option>
			<option value="3">March {{year_segment2}}</option>
			<option value="4">April {{year_segment2}}</option>
			<option value="5">May {{year_segment2}}</option>
			<option value="6">June {{year_segment2}}</option>-->

      <option value="7">July {{year_segment1}}</option>
      <option value="8">August {{year_segment1}}</option>
      <option value="9">September {{year_segment1}}</option>
      <option value="10">October {{year_segment1}}</option>
      <option value="11">November {{year_segment1}}</option>
      <option value="12">December {{year_segment1}}</option>
      <option value="1">January {{year_segment2}}</option>
      <option value="2">February {{year_segment2}}</option>
      <option value="3">March {{year_segment2}}</option>
      <option value="4">April {{year_segment2}}</option>
      <option value="5">May {{year_segment2}}</option>
      <option value="7">June {{year_segment2}}</option>

		  </select>
		</div>
	  </div>      
      
   	  <div class="form-group row" style="display: none;">
		<label for="status"  class="col-md-2 col-form-label">Payroll run Type</label>
		<div class="col-md-4">
		  <select id="payrun_type" v-model="payrun_type" name="payrun_type" required class="form-control ">
            <option value="9">Manual Payroll Run</option>
		  </select>
		</div>
	  </div>
      


	  <div class="form-group row">
		<div class="col-md-2">
		  <button class="btn btn-success btn-full-width">Submit</button>
		</div>
        
        <div class="col-md-2" v-if="loading != ''">
          <img :src="pgurl+'/images/loading.gif'" width="30">
        </div>
        
	  </div>
    	</form>
        <div class="col-md-12 pay-run-loader overflow-hidden text-center" v-if="loading != ''">
            <h3 style="color: #fff;">{{month_name}} - {{year_segment}}</h3>
            <p style="color: #fff;">Alright world, time to take you on!<br/>Payrun calculations in progress ...</p>
            <img :src="pgurl+'/images/loading.gif'" width="40">
            <div class="loading-stroke"></div>
            <b-progress :max="number_of_employees" class="payroll-progress" show-progress animated>
                <b-progress-bar :value="progress_value" :label="(progress_value)+' / '+(number_of_employees)"></b-progress-bar>
            </b-progress>
        </div>
  
  
  
</b-card>
    
  <!-- Modal Content Ends -->
  </b-modal>
</div>
  </div>
  
  
  </template> 
  <script>
	  import moment from 'moment';
      export default{
		  props: ['pageurl', 'company_name', 'current_fiscal_year'],
		  mounted() {
			  console.log('started..');            
		  },
		  data(){
		      let sortOrders = {};
              let columns = [
                            {label: 'Type', name: 'run_type' },
                            {label: 'Fiscal year', name: 'fiscal_year'},
                            {label: 'Employer PF Contribution', name: 'earnings'},
                            {label: 'Employee PF Contribution', name: 'additions'},
                            {label: 'Total PF Contribution', name: 'total_earnings'},
                            
                            
                        ];
              columns.forEach((column) => {sortOrders[column.name] = -1;});
              
              /* for approved payruns */
              let sortOrders_two = {};
              let columns_two = [
                            {label: 'Type', name: 'run_type' },
                            {label: 'Fiscal year', name: 'fiscal_year'},
                            {label: 'Employer PF Contribution', name: 'earnings'},
                            {label: 'Employee PF Contribution', name: 'additions'},
                            {label: 'Total PF Contribution', name: 'total_earnings'},
                            
                        ];
              columns_two.forEach((column) => {sortOrders_two[column.name] = -1;});
              /* for approved payruns */
              
			  return {
			     /** Sohel Code Starts Here */
                  blankmsg : 'Fetching data..',
                  this_search : '',
                  columns: columns,
                  sortKey: '',
                  sortOrders: sortOrders,
                  length : 20,
                  temp_length: 20,
                  length_options: [],
                  this_pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                  approved_loader : true,
                  
                  /* for approved payruns */
                  blankmsg_two : 'Fetching data..',
                  this_search_two : '',
                  columns_two: columns_two,
                  sortKey_two: '',
                  sortOrders_two: sortOrders_two,
                  length_two : 20,
                  temp_length_two: 20,
                  length_options_two: [],
                  this_pagination_two : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                  /* for approved payruns */
                  
                  decimal_setting: '',
        
                  /** Sohel Code Ends Here */
                  
				  payruns : [], 
                  payrunsapproved : [], 
                  payrunsfiscalyear: [], 
				  payrunyears: [],
                  manual_payrunyears:[],
				  employees : [],              
				  pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
				  paginationapproved: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
				  search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                  pagination_length: 0,
                  link_tracker:0,
                  
                  approved_pagination_length: 0,
                  approved_link_tracker:0,
                  manual_payrun_status:'',
                  year_manual:[],                  
				 // search_by_id:{company_employee:''},
                 
				  per_page:10, 
                  per_pageapproved:10,               
				  pgurl:this.$api_url,
                  company_title: this.company_name,
                  cur_fiscal_year: this.current_fiscal_year,
                  pending_payruncount:0,
                  approved_payruncount:0,
                  approvepass: '',
                  incorrectpass: '',
                  unapproval_payrun_id: '',
                  approval_payrun_id:'',
                  payrun_type: 0,
                  year_segment1:'',
                  year_segment2:'',
                  year_segment3:'',
                  year_segment4:'',
                  payrunmodaltitle:"Create Off-Cycle Payroll Run",
                  ///////new payrun components starts////
                  success: '',
				  id: '',
				  month: '',
				  year: '',
                  loading:'',
                  error_msg: '',
                  ///////new payrun components end////
                  
                  
                  ////////////Final Settlement Modal elements Start/////////
                    users : [], 
                    challanemployees : [], 
                    employeenames : [],
                    employeeids : [],
                    employeesearch:{name:''},
                    current_employee_id:0,                    
                  ////////////Final Settlement Modal elements End/////////   
                  
                  payslip_process: false,                                                                                                          
                  payslip_process_two: true,                                                                                                          
                  loading: '',                  
                  year_segment:'',                                                                                                        
                  month_name:'',                                                                                                      
                  number_of_employees:0,
                  progress_value : 0,                                                                                                       
                  last_payrun_date : '',  
                  off_cycle_error_msg : '',  
                  
                  
                  
                  
  
			  }
		  },
		  methods:{
		      
                    formatMe(d)
                    {
                       return moment(d).format('YYYY/MM/DD');
                    },
                    
                    formatTime (d)
                    {
                        return moment(d).format('hh:mm:ss A');
                    },
		      
     
    			  /* approved payruns */
                  sortBy_two(key) 
                  {
                      this.resetPagination_two();
                      this.sortKey_two = key;
                      this.sortOrders_two[key] = this.sortOrders_two[key] * -1;
                  },
                  getIndex(array, key, value) 
                  {
                      return array.findIndex(i => i[key] == value)
                  },
    			  /* approved payruns */
                  
                  finalSettlementsetSearch: function(pageflg)
    			  {
    				  this.finalSettlementgetEmployees();
    			  },
      
    			  
    		      finalSettlementgetEmployees: function()
    			  {
    			     if(this.employeesearch.name!="")
    			     document.getElementById("employee_dropdown").style.display="block";
                     else
                     document.getElementById("employee_dropdown").style.display="none";
      
    						  axios.get(this.$api_url+'/final_settlement_employee_list' , {
    							  params: {
    								  page: 1,
    								  per_page: 15,
    								  employee_name: this.employeesearch.name,
                                      month: this.month,
                                      year: this.year,
    								  search_query_by_id: '',
    							  }
    					  }).then(function(response){
    					  this.users = response.data.employees;
    				  }.bind(this));
    			  },
                  
                  
                  
          		  chooseemployee: function(name, id)
        		  { 
              
            		  
            		  if (this.employeeids.indexOf(id) === -1) {
            					  
            					  this.employeesearch.name=name;
                                  this.current_employee_id=id;
            					  this.users=[];
                                  document.getElementById("employee_dropdown").style.display="none";
            
            				 
            				}
            				else
            				{alert("This employee already added.");}
            				  

					  this.employeenames.push(this.employeesearch.name);
					  this.employeeids.push(this.current_employee_id);
                      this.employeesearch.name="";
                                                                                                                        
        		  },
                  
                  
      		      removeemployee: function(index)
    			  {
    					  this.employeeids.splice(index, 1);
    					  this.employeenames.splice(index, 1);
    			  },

         
              
              
		  
		  
		  	  getpayrunyears: function()
			  {
	   		axios.get('/get/fiscalyear/list').then(function(response){
					  this.payrunyears = response.data;
  
				  }.bind(this));
			  },
              



		  	  get_manual_payrunyears: function()
			  {
						  axios.get(this.$api_url+'/get_manual_payrun-years' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.manual_payrunyears = response.data;
  
				  }.bind(this));
			  },
              

              
              
                            
              getManualPayrunStatus: function()
			  {
  
						  axios.get(this.$api_url+'/allow-manual-payrun' , {
							  params: {
							     
                                 fiscal_year:this.cur_fiscal_year,

							  }
					  }).then(function(response){
					   
					  this.manual_payrun_status = response.data.data;
                      
                      //alert(this.manual_payrun_status);                                            
  
  
				  }.bind(this));
			  },
              



		      
              
              displaypayrunmodal: function()
			  {
                this.success= '';
                this.month='';
                this.year='';
			    this.$bvModal.show('payrun_modal');
              },
              
              
              display_manual_payrunmodal: function()
			  {
                this.success= '';
                this.month='';
                this.year='';
                this.year_segment1='';
                this.year_segment2='';
                this.payrun_type=9;
			    this.$bvModal.show('manual_payrun_modal');
              },
              
              
              
              linkGen: function(pageNum)
			  {
			     if(this.link_tracker!=this.pagination.currentPage)
                 {
                    this.link_tracker=this.pagination.currentPage;
                    this.getpayruns();
                 }
                 
              },
              
              
              
              runOffcycle: function(payrunid=0, month='', year='')
			  {
                var months = ["", "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
                
                var yr = year ? year.split("-"): 0;
                
                if(parseInt(this.month) > 6){
                    this.year_segment = yr[1];
                }else{
                    this.year_segment = yr[0];
                }
                
                this.month_name = months[month];
                
                this.success= '';
                this.month=month;
                this.year=year;
                this.payrun_type=1;
                this.payrunmodaltitle="Create Off-Cycle Payroll Run";
			    this.$bvModal.show('payrun_modal');
              },
              
              
              runFinalsettltment: function(payrunid=0, month='', year='')
			  {
                var months = ["", "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
                
                var yr = year.split("-");
                 
                if(parseInt(this.month) > 6){
                    this.year_segment = yr[1];
                }else{
                    this.year_segment = yr[0];
                }
                
                this.month_name = months[month];
                
                this.success= '';
                this.month=month;
                this.year=year;
                this.payrun_type=2;
                this.payrunmodaltitle="Create Final Settlement";
			    this.$bvModal.show('payrun_modal');
              },

              
              
              
              linkGen: function(pageNum)
			  {
			     if(this.link_tracker!=this.pagination.currentPage)
                 {
                    this.link_tracker=this.pagination.currentPage;
                    this.getpayruns();
                 }
                 
              },
              
              
              
              
              linkGenapproved: function(pageNum)
			  {
			     if(this.approved_link_tracker!=this.paginationapproved.currentPage)
                 {
                    this.link_tracker=this.paginationapproved.currentPage;
                    this.getpayrunsapproved();
                 }
                 
              },
              
              
              
              setfiscalyear: function()
			  {
			     var yr=this.year.split("-");
                 this.year_segment1=yr[0];
                 this.year_segment2=yr[1];
                 //alert(yr[0]);
                 
              },
              
              setYear: function()
              {
                var months = ["", "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
           
                if(parseInt(this.month) > 6){
                    this.year_segment = this.year_segment2;
                }else{
                    this.year_segment = this.year_segment1;
                }
                
                this.month_name = months[this.month];
              },
              
              
              
                 formSubmit(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
                  let payrun_date_error = false;
                 
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
                  
                 if(this.year.length <= 0 || this.month.length <= 0){
                    currentObj.$bvToast.toast("Please fill the form correctly before continue!!!", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                    return false;
                 }
                 
                 var months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
                 var year_value = '';
                 var month_name = months[this.month];
                 var yr=this.year.split("-");
                 this.year_segment1=yr[0];
                 this.year_segment2=yr[1];
                 
                 if(parseInt(this.month) > 6)
                 year_value =  this.year_segment1;
                 else
                 year_value =   this.year_segment2;
                 
                this.year_segment = year_value;
                this.month_name = month_name;
                 
                 let date_last_payrun = new Date(Date.parse(this.last_payrun_date));
                 let date_payroll_run = new Date(Date.parse(year_value+"-"+this.month+"-1"));
                
                 
                  if(date_payroll_run.getFullYear() < date_last_payrun.getFullYear())
                  payrun_date_error = true;
                  else if(date_payroll_run.getFullYear() == date_last_payrun.getFullYear()){
                    if(date_payroll_run.getMonth() < date_last_payrun.getMonth())
                    payrun_date_error = true;
                  }
                 
                 if(payrun_date_error){
                    currentObj.$bvToast.toast("You can't create a Payroll Run on "+month_name+" "+year_value+" as Payroll Run created after this!!!", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                    return false;
                 }
                  this.loading='load';
                  currentObj.error_msg='';
                  
				  let formData = new FormData();
                  
                  var payslip_type='';
                  
                  if(this.payrun_type==1)
                  {
                      payslip_type='?payslip_type=off_cycle'
                      
                      // Payrun progress bar code start
                      let check_payrun = setInterval(() => {
                          axios.get(this.$api_url+'/get-inactive-payrun-payslips', {
                            params: {
                                
                            }
                          }).then(function(response){
                            //console.log(response.data);
                            if(response.data.payslip_count != 0){
                                currentObj.payslip_array = response.data;
                                currentObj.payslip_process = true;
                                
                                for (let [key, value] of Object.entries(currentObj.payslip_array)) 
                                {
                                    currentObj.number_of_employees = value.payslip_count;
                                    currentObj.progress_value = value.created_payslip_count;
                                }                            
                            }else{
                                clearInterval(check_payrun);
                                currentObj.payslip_process = false;
                            }
                            
                          }.bind(this)).catch(function (error){ currentObj.output = error;});
                      }, 3000);
                      // Payrun progress bar code end
      
    				  axios.get(this.$api_url+'/salary-slips-company/'+this.month+'/'+this.year+'/0'+payslip_type, formData, config)
      
    				  .then(function (response) {
      
    					   if(response.data.error_msg){
    					       currentObj.$bvToast.toast(response.data.success, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                               currentObj.off_cycle_error_msg = response.data.success;
                               return false;
    					   }else{
    					       currentObj.success = response.data.success;
                               currentObj.setSearch();
                               currentObj.loading='';
                               currentObj.off_cycle_error_msg='';
        					   currentObj.$bvModal.hide('payrun_modal');
    					   }
      
    				  })
      
    				  .catch(function (error) {
                          currentObj.$bvModal.hide('payrun_modal');
                          currentObj.error_msg="Operation Failed. "+error;
                          currentObj.loading='';
                          
    					  //currentObj.output = error;
      
    				  });
                  }
                  
                  if(this.payrun_type==2)
                  {
                      payslip_type='?payslip_type=off_cycle'
                      formData.append('selected_emloyee_ids', this.employeeids);
                      this.payrun_type = 0;
                      var total_payslips = this.employeeids.length;
                      
                      // Payrun progress bar code start
                      let check_payrun = setInterval(() => {
                          axios.get(this.$api_url+'/get-inactive-payrun-payslips/?payslip_type=final_settlement&total_payslips='+total_payslips, {
                            params: {
                                
                            }
                          }).then(function(response){
                            //console.log(response.data);
                            if(response.data.payslip_count != 0){
                                currentObj.payslip_array = response.data;
                                currentObj.payslip_process = true;
                                
                                for (let [key, value] of Object.entries(currentObj.payslip_array)) 
                                {
                                    currentObj.number_of_employees = value.payslip_count;
                                    currentObj.progress_value = value.created_payslip_count;
                                }                            
                            }else{
                                clearInterval(check_payrun);
                                currentObj.payslip_process = false;
                            }
                            
                          }.bind(this)).catch(function (error){ currentObj.output = error;});
                      }, 3000);
                      // Payrun progress bar code end
    				  axios.post(this.$api_url+'/final_settlement_payrun/'+this.month+'/'+this.year+'/0'+payslip_type, formData, config)
      
    				  .then(function (response) {
      
    					  currentObj.success = response.data.success;
                           currentObj.setSearch();
                           currentObj.loading='';
    					   currentObj.$bvModal.hide('payrun_modal');
      
    				  })
      
    				  .catch(function (error) {
                          currentObj.$bvModal.hide('payrun_modal');
                          currentObj.error_msg="Operation Failed. "+error;
                          currentObj.loading='';
                          
    					  //currentObj.output = error;
      
    				  });
                    
                  }
  
			  },





                 formSubmit_manual(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
  
                  this.loading='load';
                  currentObj.error_msg='';
                  
                  // Payrun progress bar code start
                  let check_payrun = setInterval(() => {
                      axios.get(this.$api_url+'/get-inactive-payrun-payslips', {
                        params: {
                            
                        }
                      }).then(function(response){
                        //console.log(response.data);
                        if(response.data.payslip_count != 0){
                            currentObj.payslip_array = response.data;
                            
                            for (let [key, value] of Object.entries(currentObj.payslip_array)) 
                            {
                                currentObj.number_of_employees = value.payslip_count;
                                currentObj.progress_value = value.created_payslip_count;
                            }                            
                        }else{
                            clearInterval(check_payrun);
                        }
                        
                      }.bind(this)).catch(function (error){ currentObj.output = error;});
                  }, 3000);
                  // Payrun progress bar code end
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
                  

                      var payslip_type='?payslip_type=manual';
      
    				  axios.get(this.$api_url+'/salary-slips-company/'+this.month+'/'+this.year+'/0'+payslip_type, formData, config)
      
    				  .then(function (response) {
      
    					  currentObj.success = response.data.success;
                           currentObj.setSearch();
                           currentObj.loading='';
    					   currentObj.$bvModal.hide('manual_payrun_modal');
      
    				  })
      
    				  .catch(function (error) {
                          currentObj.$bvModal.hide('manual_payrun_modal');
                          currentObj.error_msg="Operation Failed. "+error;
                          currentObj.loading='';
                          
    					  //currentObj.output = error;
      
    				  });
                 
                  

  
			  },



		  
			
			  setSearch: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
				  this.getpayruns();
                  this.getpayrunsapproved();
			  },
			  setPagination: function(pageflg)
			  {                
				  if(pageflg)
					  this.pagination.currentPage = this.pagination.nextPage;
				  else    
					  this.pagination.currentPage = this.pagination.prevPage;
				  
				  this.getpayruns();
			  },
              
			  getpayruns: function()
			  {
          var yr=this.search.fiscal_year.split("-"); //at_edit
          this.year_segment3=yr[0];
          this.year_segment4=yr[1];

						  axios.get(this.$api_url+'/list-all-payruns' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					  this.payruns = response.data.data;
                      this.length_options = [{ value: 5, text: "5" },
                                                { value: 10, text: "10" },
                                                { value: 20, text: "20" }, 
                                                { value: this.payruns.length, text: "All" }
                                            ];
                                            
                      this.pending_payruncount=this.payruns.length;
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
                      
                      if(this.pagination.total>0)
                      {
                        this.pagination_length=Math.ceil((this.pagination.total/this.per_page));
                      }
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },
              
              /* Sohel */
              get_decimal_settings: function()
              {
                  axios.get(this.$api_url+'/decimal-settings')
  
				  .then(function (response) {
				    this.decimal_setting = response.data;  
				  }.bind(this));
              },
              sumTotals: function(value1, value2)
              {
                let sum = 0;
                let val1 = value1.replace(/\,/g,'');
                let val2 = value2.replace(/\,/g,'');
                sum = (parseFloat(val1) + parseFloat(val2)).toFixed(2);
                if(this.decimal_setting == 'no'){
                    //sum = (parseInt(val1) + parseInt(val2));
                    sum = sum;
                }else{
                    sum = sum;                    
                }
                sum = sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                return sum;
              },
              paginate(array, length, pageNumber) 
                {
                    let l = parseInt(array.length);
                    let m = parseInt(length);
                    this.this_pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
                    this.this_pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
                    this.this_pagination.prevPage = pageNumber > 1 ? pageNumber : '';
                    this.this_pagination.nextPage = array.length > this.this_pagination.to ? pageNumber + 1 : '';
        
                    if(l > 0)
                    {
                        this.this_pagination.pages = Math.ceil(l / m);
                    }
                    return array.slice((pageNumber - 1) * length, pageNumber * length);
                },
                resetPagination()
                {
                    this.this_pagination.currentPage = 1;
                    this.this_pagination.prevPage = '';
                    this.this_pagination.nextPage = '';
                },
                setFirstPage()
                {  
                    this.this_pagination.currentPage = 1;                
                    this.length = this.temp_length;   
                },
                
                /* approved payruns */
                paginate_two(array, length, pageNumber) 
                {
                    let l = parseInt(array.length);
                    let m = parseInt(length);
                    this.this_pagination_two.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
                    this.this_pagination_two.to = pageNumber * length > array.length ? array.length : pageNumber * length;
                    this.this_pagination_two.prevPage = pageNumber > 1 ? pageNumber : '';
                    this.this_pagination_two.nextPage = array.length > this.this_pagination_two.to ? pageNumber + 1 : '';
        
                    if(l > 0)
                    {
                        this.this_pagination_two.pages = Math.ceil(l / m);
                    }
                    return array.slice((pageNumber - 1) * length, pageNumber * length);
                },
                resetPagination_two()
                {
                    this.this_pagination_two.currentPage = 1;
                    this.this_pagination_two.prevPage = '';
                    this.this_pagination_two.nextPage = '';
                },
                setFirstPage_two()
                {  
                    this.this_pagination_two.currentPage = 1;                
                    this.length_two = this.temp_length_two;   
                },
                /* approved payruns */
                
                /* Sohel */
              
              
              
             getpayrunsfiscalyear: function()
			  {
  
						  axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: 100,
								  search_query: '',
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.payrunsfiscalyear = response.data.data;
  
					  /*this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;*/
				  }.bind(this));
			  },
              
              
              getpayrunsapproved: function()
			  {
  
              this.approved_loader = true;
						  axios.get(this.$api_url+'/list-payruns/1' , {
							  params: {
								  page: this.paginationapproved.currentPage,
								  per_page: this.per_pageapproved,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
              this.approved_loader = false;
					  this.payrunsapproved = response.data.data;
                      this.length_options_two = [{ value: 5, text: "5" },
                                                { value: 10, text: "10" },
                                                { value: 20, text: "20" }, 
                                                { value: this.payrunsapproved.length, text: "All" }
                                            ];
                      this.approved_payruncount=this.payrunsapproved.length;
					  this.paginationapproved.from = response.data.from;
					  this.paginationapproved.to = response.data.to;
					  this.paginationapproved.total = response.data.total;
                      
                      
                      if(this.paginationapproved.total>0)
                      {
                        this.approved_pagination_length=Math.ceil((this.paginationapproved.total/this.per_pageapproved));
                      }
                      
                      
					  
					  if(this.paginationapproved.to==this.paginationapproved.total)
					  {
						  
						  this.paginationapproved.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.paginationapproved.nextbuttonstatus = '';
					  }
					  
					  if(this.paginationapproved.from==1)
					  {
					  this.paginationapproved.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.paginationapproved.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.paginationapproved.currentPage < response.data.last_page)
						  this.paginationapproved.nextPage = this.paginationapproved.currentPage + 1;
  
					  if(this.paginationapproved.currentPage == 1)
						  this.paginationapproved.prevPage = 1;
					  else 
						  this.paginationapproved.prevPage = this.paginationapproved.currentPage - 1;
				  }.bind(this));
			  },
              
              setSearchapproved: function(pageflg)
			  {
				  this.paginationapproved.currentPage = 1;
				  this.getpayrunsapproved();
			  },
			  setPaginationapproved: function(pageflg)
			  {                
				  if(pageflg)
					  this.paginationapproved.currentPage = this.paginationapproved.nextPage;
				  else    
					  this.paginationapproved.currentPage = this.paginationapproved.prevPage;
				  
				  this.getpayrunsapproved();
			  },
              
              
              seturlSearch: function()
              {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                var get_year = String(urlParams.get('fiscal_year'));
                var get_month = String(urlParams.get('month'));

                if(get_year=="" || get_year=='null')
                this.search.fiscal_year="";
                else
                this.search.fiscal_year=get_year;
                
                if(get_month=="" || get_month=='null')
                this.search.month="";
                else
                this.search.month=get_month;
                
              },
              
              
              showUnApproveModal: function(pageflg)
              {
                this.unapproval_payrun_id=pageflg;
                this.$bvModal.show('pass-modal'); 
                this.approvepass='';
              },
              
              
              showApproveModal: function(pageflg)
              {
                this.approval_payrun_id=pageflg;
                this.$bvModal.show('approve-modal');
                this.approvepass=''; 
              },


          
              unapprovePayrun: function(pageflg)
			  {

                                                                    
                 if(this.approvepass!='')
                 {
                  var pass=this.approvepass;  
			      this.loading='load';
                                                
				  this.pagination.currentPage = 1;
						  axios.get(this.$api_url+'/payrun-update-status/'+pageflg+'/0', {
							  params: {
								  jsonmode: 'on',
                                  pass: pass,								 
							  }
					  }).then(function(response){
					   
					  //this.fdata.status = response.data.success;
                      if(response.data.success=='1')
                      {
                       this.incorrectpass='';
                       this.$bvModal.hide('pass-modal'); 
                       
                            this.getpayruns();
                            this.getpayrunsfiscalyear();
                            this.getpayrunyears();
                            this.getpayrunsapproved();
                            this.seturlSearch();
                      
                      }
                      else
                      {
                        this.incorrectpass="Incorrect Password";
                      }  
                      this.loading='';                      
  
					  
				  }.bind(this));
                  }                  
                  
				 // this.getchallans();
			  },                  


              approvePayrun: function(pageflg)
			  {
                 if(this.approvepass!='')
                 {
                  var pass=this.approvepass;  
			      this.loading='load';
                                                
				  this.pagination.currentPage = 1;
						  axios.get(this.$api_url+'/payrun-update-status/'+pageflg+'/1', {
							  params: {
								  jsonmode: 'on',
                                  pass: pass,								 
							  }
					  }).then(function(response){
					   
					  //this.fdata.status = response.data.success;
                      if(response.data.success=='1')
                      {
                       this.incorrectpass='';
                       this.$bvModal.hide('approve-modal'); 
                       
                            this.getpayruns();
                            this.getpayrunsfiscalyear();
                            this.getpayrunyears();
                            this.getpayrunsapproved();
                            this.seturlSearch();
                      
                      }
                      else
                      {
                        this.incorrectpass="Incorrect Password";
                      }  
                      this.loading='';                      
  
					  
				  }.bind(this));
                  }                  
                  
				 // this.getchallans();
			  },                  


			 checkChallanCreated: function(payrun_id)
             {
                
			   let currentObj = this;
			   axios.get(this.$api_url+'/payrun/checkchallancreated/'+payrun_id, {
               params: {
                  }
                }).then(function (response) {
                if(parseInt(response.data.challan_total)>0)
                //alert('Not allowed');
                currentObj.$bvToast.toast("You cannot un-approve this payroll run. It is found that you have created Challan(s) already under this payrun. If you still want to unapprove this payrun, please delete the challan(s) associated with this payrun accordingly and try again.", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                currentObj.showUnApproveModal(payrun_id);
			  })
			  .catch(function (error) {
				  currentObj.output = error;
			  });
                
           },
           countPayslip: function()
              {
                  let x = setInterval(() => {
                      axios.get(this.$api_url+'/get-inactive-payrun-payslips', {
                        params: {
                            
                        }
                      }).then(function(response){
                        //console.log(response.data);
                        if(response.data.payslip_count != 0){
                            this.payslip_process = true;
                            this.payslip_process_two = true;
                            /*if(response.data.payslip_count == response.data.created_payslip_count){
                                this.payslip_process = false;
                                clearInterval(x);
                            }*/
                        }else{
                            this.payslip_process = false;
                            this.payslip_process_two = false;
                            clearInterval(x);
                        }
                        
                      }.bind(this)).catch(function (error){ this.output = error;});
                  }, 3000);
              },
              
              onHidden (e) {
                console.log('the modal was hidden');
                window.location.reload();
              },
             getLastPayrunDate(){
              axios.get(this.$api_url+'/get_company_last_payrun_date', {
                                params: {
                                }
                        }).then(function(response){
                        //alert(); 
                        //console.log(response.data);  
                        if(response.data){
                         
                         var last_payrun_data = response.data.split("-");
                         
                         if(last_payrun_data[0] && last_payrun_data[1])
                         this.last_payrun_date = last_payrun_data[0]+"-"+last_payrun_data[1]+"-1";  
                         //alert(this.last_payrun_date);
                         
                        }else{
                          this.last_payrun_date = '';  
                        }
                        
               }.bind(this));
            },
            
            hidePayrunModal(){
                this.$bvModal.hide('payrun_modal');
            }
  
		  },
          
                    
		  created: function(){
			  this.getpayruns();
              this.getpayrunsfiscalyear();
			  this.getpayrunyears();
              this.getpayrunsapproved();
              this.seturlSearch();
              this.getManualPayrunStatus();
              this.get_manual_payrunyears();
              this.countPayslip();
              this.get_decimal_settings();
              this.getLastPayrunDate();
              
		
		  },
          computed: 
         {

            filteredData() 
            {
                let filtered_list = this.payruns;
                if (this.this_search) 
                {
                  
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.this_search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.this_pagination.currentPage);
            },
            filteredData_two() 
            {
                let filtered_list = this.payrunsapproved;
                if (this.this_search_two) 
                {
                  
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.this_search_two.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey_two;
                let order = this.sortOrders_two[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns_two, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns_two[index].type && this.columns_two[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns_two[index].type && this.columns_two[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData_two() 
            {     
                return this.paginate_two(this.filteredData_two, this.length_two, this.this_pagination_two.currentPage);
            }
         }
	  }
  </script>
  <style>
  button.disabled{
	  cursor: default;
  }
  
  .tb-border{
    border: 1px solid #808080;
    border-radius: 0.25rem !important;
    border-collapse: separate;
}

.tb-border td{
    padding: 2px !important;
}
  
  </style>